import { render, staticRenderFns } from "./AcceptWorkspaceInvitation.vue?vue&type=template&id=e3ce07ce"
import script from "./AcceptWorkspaceInvitation.vue?vue&type=script&lang=js"
export * from "./AcceptWorkspaceInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3ce07ce')) {
      api.createRecord('e3ce07ce', component.options)
    } else {
      api.reload('e3ce07ce', component.options)
    }
    module.hot.accept("./AcceptWorkspaceInvitation.vue?vue&type=template&id=e3ce07ce", function () {
      api.rerender('e3ce07ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accept-workspace-invitation/AcceptWorkspaceInvitation.vue"
export default component.exports